var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.60742,1.917,12.19434,3.33105l1.41351,1.41224-3.1518,3.15222L6.73926,8.7832,3.71143,11.81152l3.535,3.53492L3,19.58569V21H4.41425l4.24639-4.23926,3.53614,3.53614,3.02783-3.02833.88818-3.71679,3.15461-3.15418,1.41522,1.41394,1.41308-1.41406Zm.6919,10.6211-.88819,3.71679-1.21435,1.21387L6.53955,11.81152l1.21436-1.21386L11.4707,9.71l3.55194-3.55322,2.83008,2.82751Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/Pin.230f0a32dd828160f0543e9721e5741e.svg";
export { ForwardRef as ReactComponent };